import { render, staticRenderFns } from "./VideoPreviewThumb.vue?vue&type=template&id=65095f3e"
import script from "./VideoPreviewThumb.vue?vue&type=script&lang=js"
export * from "./VideoPreviewThumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports